const AUDITOR_ATTRIBUTION_POLICY: Readonly<{ suppressAuthors: boolean }> = {
  suppressAuthors: false,
};

function shouldHideAuditorAttribution(isAuditor: boolean): boolean {
  return AUDITOR_ATTRIBUTION_POLICY.suppressAuthors && isAuditor;
}

export { shouldHideAuditorAttribution };
